import './Badge.scss'

export const Badge = ({
  children,
  variant = 'default',
  size = 'md',
  dot = false,
  color,
  className = '',
}) => {
  const classes = [
    'tb-badge',
    `tb-badge--${variant}`,
    `tb-badge--${size}`,
    dot && 'tb-badge--dot',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  const customStyle = color
    ? { backgroundColor: color + '20', color: color, borderColor: color + '40' }
    : {}

  return (
    <span className={classes} style={customStyle}>
      {dot && (
        <span
          className="tb-badge__dot"
          style={color ? { backgroundColor: color } : {}}
        />
      )}
      {children}
    </span>
  )
}
